import { observer } from "mobx-react-lite";
import useDefaultMapLayer from "../../hooks/useDefaultMapLayer";
import { ILayerWithAbilityToOverrideIsStyleLoadedProps } from "../../interfaces/IlayerProps";

function SatelliteMapboxBaseMapLayer({ visible, isStyleLoadedOverride }: ILayerWithAbilityToOverrideIsStyleLoadedProps) {
    useDefaultMapLayer(visible, () => [
        "mapbox-satellite",
    ], isStyleLoadedOverride);

    return (
        <></>
    );
}

export default observer(SatelliteMapboxBaseMapLayer);